import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
};

const findIndex = (items, id) =>
  items.findIndex((item) => String(item.id) === String(id));

const CartReducer = createSlice({
  name: "CartReducer",
  initialState,
  reducers: {
    // Add a product to the cart (or bump its quantity if already present).
    addToCartList: (state, action) => {
      const product = action.payload || {};
      const index = findIndex(state.items, product.id);
      const addedQty = Number(product.qty) > 0 ? Number(product.qty) : 1;

      if (index >= 0) {
        state.items[index].qty += addedQty;
        return;
      }

      state.items.push({
        id: product.id,
        name: product.name ?? "Product",
        subtitle: product.subtitle ?? product.brand ?? "",
        color: product.color ?? "Default",
        price: Number(product.price) || 0,
        qty: addedQty,
        inStock: product.inStock ?? true,
        img: product.img,
      });
    },
    removeFromCart: (state, action) => {
      state.items = state.items.filter(
        (item) => String(item.id) !== String(action.payload),
      );
    },
    removeMany: (state, action) => {
      const ids = (action.payload || []).map((id) => String(id));
      state.items = state.items.filter(
        (item) => !ids.includes(String(item.id)),
      );
    },
    incrementQty: (state, action) => {
      const index = findIndex(state.items, action.payload);
      if (index >= 0) state.items[index].qty += 1;
    },
    decrementQty: (state, action) => {
      const index = findIndex(state.items, action.payload);
      if (index >= 0)
        state.items[index].qty = Math.max(1, state.items[index].qty - 1);
    },
    setQty: (state, action) => {
      const { id, qty } = action.payload || {};
      const index = findIndex(state.items, id);
      if (index >= 0) state.items[index].qty = Math.max(1, Number(qty) || 1);
    },
    clearCart: (state) => {
      state.items = [];
    },
  },
});

export const {
  addToCartList,
  removeFromCart,
  removeMany,
  incrementQty,
  decrementQty,
  setQty,
  clearCart,
} = CartReducer.actions;

export default CartReducer;
